import { generalTypes }  from '../settings/types'

const initialState = {
    viewMode: 'LIST',
    filterInfo: null,
    dataFiltered: null,
    editMode: false,
    dataToEdit: {},
    loading: false,
    disableInputs: false,
    saveSuccess: false,
}

const genericReducer = (state = initialState, action) => {
    switch (action.type) {
        case generalTypes.changeView:
            return { ...state, viewMode: action.payload}
        case generalTypes.loading:
            return { ...state, loading: action.payload}
        case generalTypes.clearState:
            return initialState
        case generalTypes.dataToEdit:
            return { ...state, dataToEdit: action.payload}
        case generalTypes.langsInData:
            return { ...state, dataToEdit:{ ...state.dataToEdit, langs: action.payload} }
        case generalTypes.enabledForm:
            return {
                ...state,
                disableInputs: !action.payload,
                saveSuccess: !action.payload,
            }
        case generalTypes.editMode:
            return { ...state, editMode: action.payload}
        case generalTypes.infoToEdit:
            return {
                ...state,
                editMode: action.payload.editMode,
                dataToEdit: action.payload.dataToEdit,
                viewMode: action.payload.viewMode
            }
        default:
            return state
    }
}

export default genericReducer